export * from './post-herausgeber.component';
export * from './post-herausgeber.component.module';